import { useRef , useEffect, useState } from "react";
import { FaBars, FaTimes} from "react-icons/fa";
import "../Styles/NavBar.css";
import logo from "../Images/logo.jpg"
import whatsapp from "../Images/whatsapp.png"
import { FaUserCircle } from "react-icons/fa";
import {auth} from '../firebase';
import Swal from "sweetalert2";


function Navbar() {
	const navRef = useRef();

	const [isLogged,setIsLogged]=useState(false);

	useEffect(() => {
		auth.onAuthStateChanged((user) => {
		  if(user){
			setIsLogged(true);
		  }else{
			setIsLogged(false);
		  }
		})
	})

	const showNavbar = () => {
		navRef.current.classList.toggle(
			"responsive_nav"
		);
	};

	const Logout = () =>{

		auth.signOut().then(Swal.fire({
			title: "Logged Out Successfully",
			text: "See You Soon!!",
			icon: "success",
			confirmButtonText: "OK",
		  })).catch((error) => {
			console.log(error);
			Swal.fire({
			  title: "Oops...",
			  text: errorBeautify(error.toString()),
			  icon: "error",
			  confirmButtonText: "OK",
			});
		  })

	}

	const NavigateToSignIn = () =>{
		window.location.href = "/signin";
	}

	function errorBeautify(inp) {
		const output = inp
		  .match(/\(auth\/(.*)\)/)[1]
		  .split("-") // split the string at the hyphen
		  .map((word) => word.charAt(0).toUpperCase() + word.slice(1)) // capitalize the first letter of each word
		  .join(" "); // join the words with a space
		return output;
	  }

	return (
		<header>
			<img src={logo} class="Nav-Logo" alt="LOGO" />
			<nav ref={navRef}>
				<a href="/">Home</a>
				<a href="/about">AboutUs</a>
				<a href="/universities">Universities</a>
				<a href="/courses">Courses</a>
				<a href="/blogs">Blogs</a>
				{isLogged?<a href="/upload">Registration</a>:<></>}
				<a class="nav-a-contactus" href="/contact">ContactUs</a>
				<button class="nav-a-signin" onClick={isLogged?Logout:NavigateToSignIn}><i><FaUserCircle/></i>{!isLogged?"Login/Register":"LogOut"}</button>
				<button
					className="nav-btn nav-close-btn"
					onClick={showNavbar}>
					<FaTimes />
				</button>
				<a class="nav-a-query" href="https://api.whatsapp.com/send?phone=918688882816">
					<img src={whatsapp} class="nav-wp-icon" alt="" />
					<p>Ask Us On 8826978461</p>
				</a>
			</nav>
			<button
				className="nav-btn"
				onClick={showNavbar}>
				<FaBars />
			</button>
		</header>
	);
}

export default Navbar;